import React from "react";
import contactArrow from '../../assets/Images/contact-arrow.png'
import { BackgroundImage, ContactForm, Map, TeethLogo } from "../../Components";

const Contact = (props) => {
    const { selectedLanguage } = props
    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_contact_us} text={selectedLanguage?.txt_experience_the_joy_of_confidence_and_better_dental_health} mainClass='contact-banner' />
            <TeethLogo heading={selectedLanguage?.txt_contact_us} text1={selectedLanguage?.txt_do_visit_our_center_for_a_consulation_and_let_our_specialists} />
            <div className="contact_form_main_div">
                <div className="contact_form_div1">
                    <div className="contact_form_div2">
                        <div className="contact_form_div3">
                            <ContactForm {...props} />
                        </div>
                        <div className="contact_image_div">
                            <img src={contactArrow} />
                        </div>
                    </div>
                    <div className="contact_map_div">
                        <Map />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact